import React, { useContext, useMemo } from "react";
import { Autocomplete, FilterBar, Switch } from "@sscs/ui";
import { produce } from "immer";
import { UNDECLARED_LICENSE } from "../../../constants";
import { initFilter, selectFilteredByLink } from "../../../store/licensesSlice";
import { LicenseFamilyFilter } from "../../common";
import { ReportContext } from "../../context";
import { useReportSelector } from "../../hooks";
import { useLazyGetLicensePoliciesQuery } from "../../services/licenses.api";
import { isFilteredByLink } from "../../utils";
import styles from "./filter.module.scss";
const Filter = ({ filter, onFilterChange }) => {
    const { reportId } = useContext(ReportContext);
    const filteredByLink = useReportSelector(selectFilteredByLink);
    const [getPolicies, { data: policiesData, isFetching: isPoliciesFetching }] = useLazyGetLicensePoliciesQuery();
    if (!policiesData &&
        !isPoliciesFetching &&
        filter.policy_id !== initFilter.policy_id) {
        // When returning to the page after navigating away and there is a policy filter applied
        // the getPolicy query will not have been run due to be lazy loaded onOpen of the autocomplete,
        // resulting in incomplete option label display. [SWAP-1809]
        getPolicies({ ui_id: reportId }, true);
    }
    const policies = useMemo(() => {
        if (!policiesData)
            return {};
        return policiesData.reduce((policiesObj, policy) => {
            policiesObj[policy.id] = policy.value;
            return policiesObj;
        }, {});
    }, [policiesData]);
    const policyIds = Object.keys(policies);
    return (React.createElement(FilterBar, { filters: [
            {
                id: "policy",
                minWidth: "280px",
                grow: 2,
                control: (React.createElement(Autocomplete, { id: "licenses-filter-policy", label: "Filter by policy ID - description", isClearAlwaysVisible: filter.policy_id !== initFilter.policy_id, options: policyIds, loading: isPoliciesFetching, onOpen: () => getPolicies({ ui_id: reportId }, true), getOptionLabel: (policyId) => { var _a; return `${policyId} - ${(_a = policies[policyId]) !== null && _a !== void 0 ? _a : ""}`; }, onChange: (_, value) => {
                        onFilterChange(produce(filter, (draftState) => {
                            draftState.policy_id = value;
                        }));
                    }, value: filter.policy_id })),
            },
            {
                id: "family",
                width: "250px",
                control: (React.createElement(LicenseFamilyFilter, { id: "licenses-filter-family", value: filter.license_family, displayUndeclared: false, onChange: (value) => {
                        if (value !== UNDECLARED_LICENSE) {
                            onFilterChange(produce(filter, (draftState) => {
                                draftState.license_family = value;
                            }));
                        }
                    }, className: styles["family-filter"], "data-filtered-by-link": isFilteredByLink(filter, initFilter, "license_family", filteredByLink) })),
            },
            {
                id: "issues",
                fit: true,
                control: (React.createElement(Switch, { title: "Filter licenses", label: "With issues", id: "licenses-filter-issues", checked: filter.only_violations, onChange: (event) => onFilterChange(produce(filter, (draftState) => {
                        draftState.only_violations = event.target.checked;
                    })) })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map